/* eslint-disable no-unused-vars */
'use strict';

const Autodesk = window.Autodesk || {};
const THREE = window.THREE;

const av = Autodesk.Viewing;
const avp = av.Private;


function BBoxCalculator(tf) {
    this.bbox = new THREE.Box3();
    this.pt = new THREE.Vector3();
    this.tf = tf;
}

BBoxCalculator.prototype.addPoint = function(x, y) {
    this.pt.set(x,y,0);
    this.tf && this.pt.applyMatrix4(this.tf);
    this.bbox.expandByPoint(this.pt);
};

BBoxCalculator.prototype.onLineSegment = function(x0, y0, x1, y1, vpId) { // eslint-disable-line no-unused-vars
    this.addPoint(x0, y0);
    this.addPoint(x1, y1);
};

BBoxCalculator.prototype.onTriangleVertex = function(x, y, vpId) { // eslint-disable-line no-unused-vars
    this.addPoint(x, y);
};

BBoxCalculator.prototype.onCircularArc = function(cx, cy, start, end, radius, vpId) { // eslint-disable-line no-unused-vars
    // Calculate points along the arc at regular intervals
    const numPoints = 16; // Number of points to sample along the arc
    const angleStep = (end - start) / (numPoints - 1);
    
    for (let i = 0; i < numPoints; i++) {
        const angle = start + (angleStep * i);
        const x = cx + radius * Math.cos(angle);
        const y = cy + radius * Math.sin(angle);
        this.addPoint(x, y);
    }
    
    // Add the center point
    this.addPoint(cx, cy);
};

BBoxCalculator.prototype.onEllipticalArc = function(cx, cy, start, end, major, minor, tilt, vpId) {
    // Calculate points along the elliptical arc at regular intervals
    const numPoints = 32; // Increased sample points for better accuracy
    const angleStep = (end - start) / (numPoints - 1);
    
    // Pre-calculate tilt transformations
    const cosTilt = Math.cos(tilt);
    const sinTilt = Math.sin(tilt);
    
    for (let i = 0; i < numPoints; i++) {
        const angle = start + (angleStep * i);
        // Parametric equations for ellipse
        const x0 = major * Math.cos(angle);
        const y0 = minor * Math.sin(angle);
        
        // Apply tilt rotation
        const x = cx + (x0 * cosTilt - y0 * sinTilt);
        const y = cy + (x0 * sinTilt + y0 * cosTilt);
        
        this.addPoint(x, y);
    }
    
    // Add the center point
    this.addPoint(cx, cy);
};

function reverseMapDbId(model, dbId) {
    return model && model.reverseMapDbId ? model.reverseMapDbId(dbId) : dbId;
}

function computeBBox2D(model, dbId) {
    // When working with 2D + Otg property db, the input dbId is an Otg one.
    // But, vertex buffers and dbId2fragIds use original dbIds. So, we need
    // to map back in this case.
    dbId = reverseMapDbId(model, dbId);

    const frags = model.getFragmentList();
    const db2frags = frags.fragments.dbId2fragId;

    let objFrags = db2frags[dbId];
    if (objFrags === undefined) {
        return null;
    }
    if (!Array.isArray(objFrags)) {
        objFrags = [objFrags];
    }

    let bboxCalc = new BBoxCalculator(model.getModelTransform());

    for (let j = 0; j < objFrags.length; j++) {
        let vbr = new avp.VertexBufferReader(frags.getGeometry(objFrags[j]));
        vbr.enumGeomsForObject(dbId, bboxCalc);
    }

    if (!bboxCalc.bbox.isEmpty()) {
        return bboxCalc.bbox;
    }
    return null;
}

function computeBBox3D(model, dbId) {
    const it = model.getData().instanceTree;
    const frags = model.getFragmentList();

    let bbox = new THREE.Box3();
    let fragBox = new THREE.Box3();

    it.enumNodeFragments(dbId, function(fragId) {

        fragBox.min.x = frags.boxes[6*fragId];
        fragBox.min.y = frags.boxes[6*fragId + 1];
        fragBox.min.z = frags.boxes[6*fragId + 2];
        fragBox.max.x = frags.boxes[6*fragId + 3];
        fragBox.max.y = frags.boxes[6*fragId + 4];
        fragBox.max.z = frags.boxes[6*fragId + 5];

        if(!fragBox.isEmpty()) {
            bbox.union(fragBox);
        }
    }, true);

    return bbox.isEmpty() ? null : bbox;
}


function computeBBox(model, dbId) {
    return model.is2d() ? computeBBox2D(model, dbId) : computeBBox3D(model, dbId);
}

exports.computeBBox = computeBBox;
